import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import AnonymousPage from '../pages/application/AnonymousPage';
import AuthenticatedPage from '../pages/application/AuthenticatedPage';
import AdminAnonymousPage from '../pages/admin/AdminAnonymousPage';
import FastOnboardPage from '../pages/application/FastOnboardPage';
import OAuthPage from '../pages/application/OAuthPage';
import SSOOnboardPage from '../pages/application/SSOOnboardPage';
import ErrorPage from '../pages/application/ErrorPage';

const container = document.getElementById('root')!;

// get data from @data set in ReactHelper
const payloadString = container.dataset.payload as string;
const jsonPayload = JSON.parse(payloadString);
const payload = jsonPayload['payload'];

// Can be set with @page_entry in ReactHelper
// or entry_override local on 'react_root' partial
// :entry_override takes precedence
const entry = container.dataset.entry as string;

function componentFromEntry(entry: string) {
  switch (entry) {
    case 'admin/AdminAnonymousPage':
      return <AdminAnonymousPage payload={payload} />;
    case 'application/AuthenticatedPage':
      return <AuthenticatedPage payload={payload} />;
    case 'application/AnonymousPage':
      return <AnonymousPage payload={payload} />;
    case 'application/FastOnboardPage':
      return <FastOnboardPage payload={payload} />;
    case 'application/OAuthPage':
      return <OAuthPage payload={payload} />;
    case 'application/SSOOnboardPage':
      return <SSOOnboardPage payload={payload} />;
    case 'application/ErrorPage':
      return <ErrorPage payload={payload} />;
    default:
      return <AnonymousPage payload={payload} />;
  }
}

const root = createRoot(container);

root.render(<StrictMode>{componentFromEntry(entry)}</StrictMode>);
